// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._9ee98a{display:flex}._9ee98a>svg{margin-top:.2em}._99655e{flex:1;position:relative;overflow:hidden}._4ada5e{position:absolute;top:0;right:0;bottom:0;left:0;display:flex}._4ada5e>*{flex:1}._4ada5e>*+*{position:relative}._4ada5e>*+*:before{content:\"\";background:linear-gradient(rgba(255, 255, 255, 0), var(--subtle) 10%, var(--subtle) 95%, rgba(255, 255, 255, 0));width:1px;position:absolute;top:0;right:0;bottom:0;left:0}._65ea03{display:flex}._65ea03>*{width:calc(100%/var(--size))}._68497c,._56bb8c{transition:transform 200ms cubic-bezier(0.86, 0, 0.07, 1)}._6a1f7c{transform:translateX(calc(var(--direction) * 100%))}._56bb8c{transform:translateX(calc(var(--direction) * -100%))}._56bb8c{position:absolute;top:0;right:0;bottom:auto;left:0}", ""]);
// Exports
exports.locals = {
	"wrapper": "_9ee98a",
	"container": "_99655e",
	"grid": "_4ada5e",
	"content": "_65ea03",
	"entering": "_68497c",
	"exiting": "_56bb8c",
	"exited": "_6a1f7c"
};
module.exports = exports;
